import { useRouter } from 'next/router';
import React from 'react';
import { TbDeviceFloppy } from 'react-icons/tb';

import { Button } from '@mantine/core';

import { useSubmitForm } from 'components/forms/Form';
import { useAction } from 'hooks/use-action';
import { LocalNotificationService } from 'services/LocalNotificationService';
import { RouterService } from 'services/RouterService';

const ComponentDatasheetActions = () => {
    const { query } = useRouter();
    const { submit: submitForm } = useSubmitForm();

    const [save, saving, _, justSaved] = useAction(async () => {
        await submitForm();

        LocalNotificationService.showSuccess({
            message: 'Component saved successfully!',
        });

        if (query.redirectAfterSave) {
            await RouterService.push(query.redirectAfterSave as string);
        }
    });

    return (
        <Button variant="filled" onClick={save} leftSection={<TbDeviceFloppy size={12} />} loading={saving}>
            {justSaved ? 'Saved' : 'Save'}
        </Button>
    );
};

export { ComponentDatasheetActions };
